import initialState from "./initialState";


const notificationReducer = (state = initialState.notification, action) => {
    switch (action.type){
        case "NEWORDER":
            return action.payload;
        case "RESETNOTIFICATION":
            return action.payload;
        default:
            return state;
    }
}

export default notificationReducer;